import React, { useState } from 'react'
import { CATEGORY_GROUP_ORDER, CATEGORY_GROUPS } from '../../utils/constants'
import { MAX_SHORT_FORM, MAX_LONG_FORM } from '../../../../shared/clicky-text.js'

export const SCOPE_LABELS = { global: 'Global', main: 'Main Category', sub: 'Sub Category' }

const EMPTY_FORM = { scope: 'global', category: '', shortForm: '', longForm: '' }

/**
 * Add or edit one clicky text. Type comes first, then the category list that
 * fits the type (master list only), then the short form and the long form.
 */
function ClickyTextForm({ item, saving, error, onSave, onCancel }) {
  const [form, setForm] = useState(() => item
    ? { scope: item.scope, category: item.category || '', shortForm: item.shortForm, longForm: item.longForm }
    : EMPTY_FORM)

  const canSave = form.shortForm.trim() && form.longForm.trim() && (form.scope === 'global' || form.category)

  function setScope(scope) {
    setForm(prev => ({ ...prev, scope, category: '' }))
  }

  function handleSubmit(e) {
    e.preventDefault()
    if (canSave) onSave(form)
  }

  return (
    <div className="modal-overlay">
      <form className="modal-content" style={{ width: '100%', maxWidth: '600px' }} onSubmit={handleSubmit}>
        <div className="modal-header">
          <h2>{item ? 'Edit clicky text' : 'Add clicky text'}</h2>
          <button type="button" className="modal-close" onClick={onCancel} aria-label="Close">&times;</button>
        </div>
        <div className="modal-body-scroll">
          <div className="form-group">
            <label className="filter-label" htmlFor="clicky-scope">Type</label>
            <select id="clicky-scope" className="form-input" value={form.scope} onChange={e => setScope(e.target.value)}>
              {Object.entries(SCOPE_LABELS).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
            </select>
          </div>

          {form.scope !== 'global' && (
            <div className="form-group">
              <label className="filter-label" htmlFor="clicky-category">{SCOPE_LABELS[form.scope]}</label>
              <CategorySelect scope={form.scope} value={form.category} onChange={category => setForm(prev => ({ ...prev, category }))} />
            </div>
          )}

          <div className="form-group">
            <label className="filter-label" htmlFor="clicky-short">Short form</label>
            <input
              id="clicky-short"
              type="text"
              className="form-input"
              value={form.shortForm}
              maxLength={MAX_SHORT_FORM}
              onChange={e => setForm(prev => ({ ...prev, shortForm: e.target.value }))}
              placeholder="For example: Scuffing"
            />
          </div>

          <div className="form-group">
            <label className="filter-label" htmlFor="clicky-long">Long form</label>
            <textarea
              id="clicky-long"
              className="form-input"
              rows={4}
              value={form.longForm}
              maxLength={MAX_LONG_FORM}
              onChange={e => setForm(prev => ({ ...prev, longForm: e.target.value }))}
              placeholder="The text that goes into the notes box when you click the short form"
            />
          </div>

          {error && <div role="alert" style={{ color: 'var(--color-error)', fontSize: 14 }}>{error}</div>}
        </div>
        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" className="btn btn-ghost" onClick={onCancel}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={!canSave || saving}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </form>
    </div>
  )
}

// Mains for Main Category; subs grouped under their main for Sub Category.
function CategorySelect({ scope, value, onChange }) {
  return (
    <select id="clicky-category" className="form-input" value={value} onChange={e => onChange(e.target.value)}>
      <option value="">Choose…</option>
      {scope === 'main'
        ? CATEGORY_GROUP_ORDER.map(main => <option key={main} value={main}>{main}</option>)
        : CATEGORY_GROUP_ORDER.map(main => (
          <optgroup key={main} label={main}>
            {CATEGORY_GROUPS[main].map(sub => <option key={`${main}-${sub}`} value={sub}>{sub}</option>)}
          </optgroup>
        ))}
    </select>
  )
}

export default ClickyTextForm
